<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-md-12 mb-lg-0 mb-4">
          <div class="card">
            <div class="card-header pb-0 p-3">
              <master-header />
            </div>
            <div class="card-body p-3">
              <master-list @transaction-selected="onTransactionSelected" />
              <masterTransaction :selected-type="selectedType" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from "./header.vue";
import masterList from "./masterList.vue";
import masterTransaction from "./transactionList.vue";

export default {
  components: {
    "master-header": header,
    "master-list": masterList,
    masterTransaction,
  },
  data() {
    return {
      selectedType: "SMART", // default type
    };
  },
  methods: {
    onTransactionSelected(type) {
      this.selectedType = type;
    },
  },
};
</script>

<style></style>
